// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8809 ? "700d6c82" : chunkId) + "." + {"1510":"c796210b1bb481fb","2759":"211207d48a688222","8083":"535698a03ce2e523","8809":"20ee01af1b3afb5d","9383":"592f658f37450aec"}[chunkId] + ".js";
};